import { Component } from "react";
import { Button, Container, FormControl, FormLabel } from "react-bootstrap";
import {

  withRouter
} from "react-router-dom";
import Form from "../../../components/Form";
import InputElement from "../../../models/common/InputElement";
import { REGIONS, TRAINING_TYPE } from "../../../utils/constants";
import * as formAction from "../../../actions/forms/FormAction";

import AddEventProps from "./AddEventProps";
import AddEventState from "./AddEventState";
import * as eventAction from "../../../actions/events/EventAction";
import EventDTO from "../../../models/EventDTO";
import { format } from "date-fns";

class AddEvent extends Component<AddEventProps, AddEventState>   {

  state: Readonly<AddEventState> = {
    mapForm: new Map<String, Array<InputElement>>(),
    clusterId: this.props.match.params["cluster"],
    event: new EventDTO(),
    eventIsFetch: false,
    email: "Enablement",
    // email: "",
    // account: "",
    howManyDays: 0,
    type: TRAINING_TYPE[0],
    showMoreFields: false
  }

  canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        this.props.history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

  componentDidMount() {
    this.canYouHaveAccess();
    const { event, clusterId } = this.state;
    let emailListener = "manual";
    // localStorage from zinfi to input field
    window.addEventListener('message', (event) => {
      var origin = event.origin; // For Chrome, the origin property is in the event.originalEvent object.
      if (origin !== 'https://partners.dynatrace.com') {
          
          return;
      }
          
      if (typeof event.data == 'object' && event.data.call=='sendValue') {
          // Do something with event.data.value;
          var userInfo = event.data.value;
          if (origin == 'https://partners.dynatrace.com') {
              console.log(userInfo);
              emailListener = userInfo.email;
              this.setState({email: emailListener});
              
          }     
          
      }
  }, false);

  }

  componentDidUpdate() {
    const { eventIsFetch, event } = this.state;
    // if (!eventIsFetch && event?.id) {
    //   this.fillInitialForm(event);
    //   this.setState({ eventIsFetch: true });
    // }

    if (this.state.showMoreFields && !eventIsFetch) {
      this.fillInitialForm(event);
      this.setState({ eventIsFetch: true });
    }


  }

  fillInitialForm(event?: EventDTO) {
    const { email, type } = this.state;
    const isReadOnly = (event?.newStage === "CHANGE" || event?.processStage === "PROCESS") ? true : false;
    let formMap = new Map();

    const emailInput = new InputElement("Email", "email", true, true, "", "", email);
    //const accountInput = new InputElement("Account", "text", true, true, "", "", account);
    let autoFilled = [emailInput];
    formMap.set("Auto-filled", autoFilled);


    let timeValue = "";
    let dateValue = "";
    const eventDateValue = event?.newDate;
    if (event && eventDateValue) {
      timeValue = format(new Date(eventDateValue), "HH:mm");
      dateValue = format(new Date(eventDateValue), "yyyy-MM-dd");
      const tempValue = (event.eventLanguage?.toUpperCase() === "ENGLISH") ? event.description?.substr(0, event.description.indexOf("|")) :
        event.description?.substr(0, event.description.indexOf("in"));
    }

    // const timeButton = new InputElement("add date", "button", false, false);

    const timezone = new InputElement("Timezone", "text", true, false, "w-50", "e.g. choose the timezone mention in the event link", event?.timezone);
    const link = new InputElement("Event link", "text", true, false, "", "e.g https://", event?.link);
    const language = new InputElement("Language", "text", true, isReadOnly, "w-50", "e.g. English", event?.eventLanguage);
    const region = new InputElement("Region", "text", true, isReadOnly, "w-50", "e.g. EMEA // if is tech-update event put EMEA region", event?.type?.region || REGIONS[0], "select", REGIONS);
    const typeInput = new InputElement("Type", "text", true, true, "w-50", "e.g. Associate", type, "select", TRAINING_TYPE);
    const description = new InputElement("Description", "text", false, type !== "WEBINAR" && type !== "HOT", "w-50", "e.g. Only for: WEBINAR type", event?.description);
    let eventInfo = [link, language, region, typeInput, description, timezone];
    for (let i = 1; i < this.state.howManyDays + 1; i++) {
      const tempDate = new InputElement("Day " + i, "date", true, false, "w-50", "e.g. date of the event. Day 1 must be the first day of the event", dateValue);
      const tempTime = new InputElement("Time " + i, "time", true, false, "w-50", "e.g. event time for the timezone choosen", timeValue);
      eventInfo.push(tempDate);
      eventInfo.push(tempTime);
    }
    formMap.set("Event Information", eventInfo);
    this.setState({ mapForm: formMap });
  }

  handleDays(event) {
    this.setState({ howManyDays: parseInt(event.target.value) });
  }

  handleType(event) {
    this.setState({ type: event.target.value });
  }

  handleMoreFields(event) {
    this.setState({ showMoreFields: true});
  }

  render() {
    const { mapForm, clusterId, howManyDays, showMoreFields, type } = this.state;
    if (showMoreFields === false) {
      return <Container className="mt-5">
        <FormLabel>How many days has the event?</FormLabel>
        <FormControl
          className="w.50"
          as="input"
          key="manyDaysEvent"
          defaultValue={howManyDays}
          name="manyDaysEvent"
          id="manyDaysEvent"
          type="number"
          onChange={this.handleDays.bind(this)}
          required={true}
          readOnly={false}
        ></FormControl>

        <FormLabel>Type</FormLabel>
        <FormControl
          className="w.50 mt-4"
          as="select"
          key="Type"
          name="Type"
          defaultValue={type}
          id="Type"
          type="text"
          onChange={this.handleType.bind(this)}
          required={true}
          readOnly={false}
        >
          {TRAINING_TYPE.map((answer, index) => <option key={index} value={answer} >{answer}</option>) || null}
        </FormControl>
        <Button className={"mt-4"} onClick={this.handleMoreFields.bind(this)} disabled={howManyDays === 0 || type === TRAINING_TYPE[0]}>Add more info</Button>
        <Button variant="info" className="mt-4 ml-3" href={'/list-events'}>Go back to list events</Button>
      </Container>
    }

    return (
      <>
        <Container className="mt-5">
          <h1>Add new Event</h1>
          <Button variant="info" className="mt-3" href={'/list-events'}>Go back to list events</Button>
        </Container>
        <Form form={mapForm} action={formAction.addEditEvent} clusterId={clusterId} formName="addOrEditForm"></Form>
      </>
    );
  }

  async getEvent(eventId: number) {
    eventAction.getEvent(eventId).then(response => {
      const event: EventDTO = response.data;
      this.setState({ event: event, howManyDays: 1 });
    })
      .catch(err => {
        alert("fail fetching selected event.");
      });
  }

}

export default withRouter(AddEvent);
